module.exports = __webpack_public_path__ + "static/media/Administracion4.f28d0ef.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/Administracion4.mp3
// module id = 711
// module chunks = 1